module.exports = __webpack_public_path__ + "img/bgaming.bd7acdea.svg";